<div class="center-image state-{{state}}">
  <div class="red state-{{state}}">

  </div>
  <div class="floating-image state-{{state}}"></div>
  <div class="bottom state-{{state}}"></div>
  <div class="top state-{{state}}"></div>
</div>

